import { createContext } from 'react'
import { CustomerCompany } from './api/dashboard'

export interface IAuthContext {
  customer: CustomerCompany | undefined
  setCustomer: React.Dispatch<React.SetStateAction<CustomerCompany | null>>
}

export const AuthContext = createContext<IAuthContext | null>(null)
